import { constants } from "shared/constants";
import { Money } from "ecom-teams-apps-core";
import { UnitType } from "../models/UnityType";
import { formatPercentageNumber } from "utils/formattingUtils";

export function getTargetValueFormat(value: number | undefined, unitType?: UnitType) {
    switch (unitType) {
        case UnitType.CURRENCY:
            return new Money(value, constants.fractionDigits).toStringWithCurrency();
        case UnitType.NUMERIC:
            return new Money(value, constants.fractionDigits).toStringWithGrouping();
        case UnitType.PERCENTAGE:
            return formatPercentageNumber(value, constants.noValue, false, false);
        default:
            return value;
    }
}
